import React from 'react';
import '../../../assets/styles/medios.css';

import logo_forbes from "../../../assets/img/medios/forbes.png";
import bloomberg from "../../../assets/img/medios/bloomberg.svg";
import laRepublica from "../../../assets/img/medios/laRepublica.svg";
// Import Swiper styles

function Medios() {
  return (
    <section id="medios" className="my-24">
      <div className="container mx-auto max-w-[300px] lg:max-w-6xl">
        <div className="flex flex-col lg:flex-row lg:items-start items-center justify-around space-y-7 lg:space-y-0">
          <a 
            // href="https://forbes.co/2023/03/10/30-promesas-2023/lokl-democratizando-la-inversion-inmobiliaria" 
            href="https://forbes.co/2023/03/10/30-promesas-2023/lokl-democratizando-la-inversion-inmobiliaria" 
            target={"_blank"}
            className="no-underline hover:text-black"
            rel="noreferrer"
          >
            <div className="w-64 text-center relative">
              <div className="flex flex-col justify-center items-center lg:absolute lg:-top-5">
                <img width={150} src={logo_forbes} alt="forbes_lokl" />
                <div className="mt-2 lg:mt-5 italic">
                  “30 promesas 2023 / Lokl: democratizando la inversión inmobiliaria”
                </div>
              </div>
            </div>
          </a>
          <a 
            href="https://www.larepublica.co/finanzas/lokl-ofrece-rentabilidad-desde-12-en-proyectos-inmobiliarios-a-traves-de-crowdfunding-3272583" 
            target={"_blank"}
            className="no-underline hover:text-black"
            rel="noreferrer"
          >
            <div className="w-64 text-center flex flex-col justify-center items-center">   
              <img src={laRepublica} alt="laRepublica_lokl" />
              <div className="mt-2 lg:mt-9 italic">
                “Una plataforma donde las nuevas generaciones han logrado invertir en proyectos inmobiliarios innovadores”
              </div>
            </div>
          </a>
          <a 
            href="https://www.bloomberglinea.com/2022/09/17/inversiones-inmobiliarias-se-toman-el-metaverso-de-la-mano-de-startup-colombiana/" 
            target={"_blank"}
            className="no-underline hover:text-black"
            rel="noreferrer"
          >
            <div className="w-64 text-center flex flex-col justify-center items-center">
              <img className="lg:mt-3" src={bloomberg} alt="bloomberg_lokl" />
              <div className="mt-4 lg:mt-12 italic">
                “Las cinco proptech que se perfilan como grandes promesas del mercado inmobiliario”
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Medios;

